import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Header, Footer, ModalBody } from './Modal.stc';
import ModalPortal from './ModalPortal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Modal({
    header,
    footer,
    onClose,
    children,
    displayName,
    dropShadow = false,
    ...restOfProps
}) {
    const { size } = restOfProps;
    Modal.displayName = displayName;
    const handleKeyUp = React.useCallback(
        (e) => {
            if (e.keyCode === 27 && typeof onClose === 'function') {
                onClose();
            }
        },
        [onClose]
    );
    return (
        <ModalPortal onKeyUp={handleKeyUp} dropShadow={dropShadow}>
            <Wrapper {...restOfProps}>
                <Header size={size} childType={typeof header}>
                    {header}
                    <button onClick={onClose}>
                        <FontAwesomeIcon icon={['fal', 'times']} />
                    </button>
                </Header>

                <ModalBody size={size}>{children}</ModalBody>

                {footer && <Footer size={size}>{footer}</Footer>}
            </Wrapper>
        </ModalPortal>
    );
}

Modal.propTypes = {
    header: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
    ]).isRequired,
    footer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
    ]),
    onClose: PropTypes.func,
};

export default Modal;
